<template>
  <el-dialog title="Nova Visita" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="50%" v-loading="loading">
    <el-form :model="visita" size="small" ref="form" :rules="validacao" label-position="top" style="margin: -20px 0px 0px 0px" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item label="Data/Hora" prop="dataHora">
            <el-date-picker
              v-model="visita.dataHora"
              v-mask="'##/##/#### ##:##'"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="Cliente">
            <el-input v-model="visita.cliente.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>      

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente">
            <el-input v-model="visita.usuario.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="height: 40%; padding: 10px 0px;">
        <el-col :span="24" style="height: 100%">
          <el-container style="height: 100%">
            <el-main style="padding: 0px; height: 100%">
              <el-table
                :data="visita.imoveis" 
                empty-text="Nenhum imóvel selecionado"
                width="100%"
                max-height="250"
                size="small"
                style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                stripe
                highlight-current-row>
                <el-table-column width="60" label="ID" prop="idNaImobiliaria"/>
                <el-table-column label="Endereço">
                  <template slot-scope="scope">
                    {{ `${scope.row.complemento && scope.row.complemento !== '' ? scope.row.complemento + ' - ' : ''}${scope.row.endereco}${scope.row.numero && scope.row.numero !== '' ? ', ' + scope.row.numero : ''}` }}
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição">
            <el-input rows="2" type="textarea" v-model="visita.descricao"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravar" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

import { validadorDataHora, validadorHora } from '../../../util/validadores.js';

export default {
  props: {
    visibility: Boolean,
    visitaPretendente: Object
  },
  data() {
    return {
      validacao: {
        dataHora : [
          { validator: validadorDataHora, trigger: 'blur' },
        ],
        hora: [
          { validator: validadorHora, required: true, message: "Hora inválida" },
        ]
      },
      visita: this.visitaPretendente
    }
  },
  computed:{
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    visitaPretendente(value) { this.visita = value; }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
  ...mapActions("vendasAtendimentosStore", [
      "gravarVisita"
    ]),
    gravar() {
      this.$refs["form"].validate((valid) => {
        if(valid){
          this.showLoading();

          this.gravarVisita(this.visita)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.warning(resultado.mensagem);
                this.fechar();
                break;
            }
          }).catch(() => {
            this.hideLoading();
          })
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },    
  }
}
</script>

